import {useListView} from '../core/ListViewProvider'
import {HotelsListToolbar} from './HotelListToolbar'
import {HotelsListGrouping} from './HotelListGrouping'
import {HotelsListSearchComponent} from './HotelsListSearchComponent'

const HotelsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <HotelsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <HotelsListGrouping /> : <HotelsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {HotelsListHeader}
